import React from 'react';
import virtualList from 'react-virtual-list';

import PDItem from './PrescriptionDropItem';
import Console from '../../../../lib/debug';

export default class PrescriptionDropList extends React.Component {
    render() {
        Console.render('designer.PDList');
        let view = null;
        let options = [];
        const classes = 'MegaDrop-item MegaDropItem-category-title';
        const itemsList = ({ virtual }) => (
            <div style={virtual.style}>
                {virtual.items.map(item => {
                    if (item.category === 'title') {
                        return (
                            <div key={`${item.id}`} className={classes}>
                                {item.title}
                            </div>
                        );
                    } else if (item.category === 'separator') {
                        return (
                            <div
                                key={`${item.id}`}
                                className="MegaDrop-item MegaDropItem-separator"
                            >
                                {item.title}
                            </div>
                        );
                    } else {
                        return (
                            <PDItem
                                submenu={this.props.submenu}
                                itemRef={el =>
                                    (this.props.itemsRef[item.id] = el)
                                }
                                key={`${item.id}`}
                                item={item}
                                onEnter={this.props.onEnterItem}
                                onLeave={this.props.onLeaveItems}
                                onSelect={this.props.onSelectItem}
                            />
                        );
                    }
                })}
            </div>
        );
        const virtualOptions = {
            container: this.props.container
        };
        const VirtualItemsList = virtualList(virtualOptions)(itemsList);

        options = (
            <VirtualItemsList
                items={this.props.items}
                itemHeight={29}
                itemBuffer={6}
            />
        );
        if (this.props.items.length) {
            view = (
                <div className="view items">
                    <div
                        className="content"
                        onMouseLeave={this.props.onLeaveItems}
                    >
                        {options}
                    </div>
                </div>
            );
        } else {
            view = (
                <div className="view items">
                    <p className="Select-noresults">
                        <i className="mdi mdi-alert" />
                        <span>No results found</span>
                    </p>
                </div>
            );
        }
        return this.props.show ? view : null;
    }
}



// WEBPACK FOOTER //
// ./src/view/designer/components/PrescriptionDrop/PrescriptionDropList.jsx